import { useBillingSummary } from '../billing/useBillingSummary';

/**
 * How many days a workspace keeps walkthrough video, as the API reports it:
 * the plan's own figure, or longer with video history. Undefined while it is
 * loading, when it could not be read, and for a viewer who cannot record there
 * (the summary leaves `recording` out for them).
 *
 * Every sentence that says how long video is kept reads this rather than a
 * plan's number: those differ by plan (7 on Free, 45 on Personal and Team, 365
 * on Business, 730 on Enterprise), staff can change them, and video history
 * extends them.
 */
export function useVideoRetentionDays(companyId: string | undefined): number | undefined {
  return useBillingSummary(companyId)?.recording?.videoRetentionDays;
}

/** "for 45 days", or the fallback when the number is not known: never a guessed plan's number. */
export function keptFor(days: number | undefined, fallback: string): string {
  return days !== undefined && Number.isFinite(days) && days > 0
    ? `for ${days} ${days === 1 ? 'day' : 'days'}`
    : fallback;
}
